import { IKeHoachThucTapPhamViActionTypes } from "../../action-types/xet-thuc-tap/IKeHoachThucTapPhamViActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IKeHoachThucTapPhamViReducer } from "../../reducer-model/xet-thuc-tap/IKeHoachThucTapPhamViReducer";

const iniState: IKeHoachThucTapPhamViReducer = {
    status: eReducerStatusBase.is_not_initialization,
    isShowAddModal: false,
    keHoachThucTapPhamVis: [],
    keHoachThucTapIdAdd: 0,
}

export const keHoachThucTapPhamViReducer = (state: IKeHoachThucTapPhamViReducer = iniState, action: IKeHoachThucTapPhamViActionTypes): IKeHoachThucTapPhamViReducer => {
    switch (action.type) {
        case "KE_HOACH_THUC_TAP_PHAM_VI_LOAD_BY_DOT_THUC_TAP_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            };
        case "KE_HOACH_THUC_TAP_PHAM_VI_LOAD_BY_DOT_THUC_TAP_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                keHoachThucTapPhamVis: action.payload
            };
        case "KE_HOACH_THUC_TAP_PHAM_VI_LOAD_BY_DOT_THUC_TAP_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "KE_HOACH_THUC_TAP_PHAM_VI_INSERT_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "KE_HOACH_THUC_TAP_PHAM_VI_INSERT_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowAddModal: false,
            };
        case "KE_HOACH_THUC_TAP_PHAM_VI_INSERT_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "KE_HOACH_THUC_TAP_PHAM_VI_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "KE_HOACH_THUC_TAP_PHAM_VI_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "KE_HOACH_THUC_TAP_PHAM_VI_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "KE_HOACH_THUC_TAP_PHAM_VI_SHOW_ADD_MODAL":
            return {
                ...state,
                isShowAddModal: true,
                keHoachThucTapIdAdd: action.payload,
            };
        case "KE_HOACH_THUC_TAP_PHAM_VI_CLOSE_ADD_MODAL":
            return {
                ...state,
                isShowAddModal: false
            };
        default:
            return state;
    }
}